(() => {
  const initStickyAtc = (root) => {
    if (!root || document.querySelector('.tsl-pdp-sticky-atc')) return;
    const original = root.querySelector('.product-form__submit');
    const form = original?.closest('form');
    if (!original || !form) return;
    const title = root.querySelector('.product__title h1')?.textContent?.trim() || '';
    const readPrice = () => root.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular')?.textContent?.trim() || '';
    const bar = document.createElement('div');
    bar.className = 'tsl-pdp-sticky-atc';
    bar.innerHTML = '<div class="tsl-pdp-sticky-atc__meta"><div class="tsl-pdp-sticky-atc__title"></div><div class="tsl-pdp-sticky-atc__price"></div></div><button type="button">Add to cart</button>';
    bar.querySelector('.tsl-pdp-sticky-atc__title').textContent = title;
    bar.querySelector('.tsl-pdp-sticky-atc__price').textContent = readPrice();
    bar.querySelector('button').addEventListener('click', () => original.click());
    document.body.appendChild(bar);
    new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(original);
    document.addEventListener('variant:change', () => {
      const price = readPrice();
      if (price) bar.querySelector('.tsl-pdp-sticky-atc__price').textContent = price;
    });
  };

  const initOffers = () => {
    document.querySelectorAll('[data-tsl-offers]').forEach((offers) => {
      const track = offers.querySelector('[data-offer-track]');
      const prev = offers.querySelector('[data-offer-prev]');
      const next = offers.querySelector('[data-offer-next]');
      if (!track) return;
      const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .78, 260), behavior: 'smooth' });
      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      offers.querySelectorAll('[data-coupon-code]').forEach((button) => {
        button.addEventListener('click', async () => {
          const code = button.dataset.couponCode;
          try {
            await navigator.clipboard.writeText(code);
            const label = button.querySelector('span:last-child');
            const old = label.textContent;
            label.textContent = 'COPIED';
            setTimeout(() => { label.textContent = old; }, 1400);
          } catch (_) {}
        });
      });
    });
  };

  const animateDetails = (details) => {
  const summary = details.querySelector(':scope > summary');
  const panel = details.querySelector(
    ':scope > .accordion__content, :scope > .rte'
  );

  if (
    !summary ||
    !panel ||
    details.dataset.tslAnimated === 'true'
  ) {
    return;
  }

  details.dataset.tslAnimated = 'true';

  const finishAnimation = () => {
    details.dataset.animating = 'false';
  };

  const openDetails = () => {
    details.open = true;
    details.dataset.animating = 'true';

    panel.style.maxHeight = '0px';
    panel.style.opacity = '0';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';
      });
    });

    const handleOpenEnd = (event) => {
      if (event.propertyName !== 'max-height') return;

      panel.removeEventListener('transitionend', handleOpenEnd);
      panel.style.maxHeight = 'none';
      finishAnimation();
    };

    panel.addEventListener('transitionend', handleOpenEnd);
  };

  const closeDetails = () => {
    details.dataset.animating = 'true';

    /*
     * When max-height is "none", first set it to the
     * panel's measured height so it has a numeric
     * value from which to animate.
     */
    panel.style.maxHeight = `${panel.scrollHeight}px`;
    panel.style.opacity = '1';

    /*
     * Force the browser to register the starting height.
     */
    panel.offsetHeight;

    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';
    });

    const handleCloseEnd = (event) => {
      if (event.propertyName !== 'max-height') return;

      panel.removeEventListener('transitionend', handleCloseEnd);

      /*
       * Close details only after the visual transition
       * has genuinely finished.
       */
      details.open = false;
      finishAnimation();
    };

    panel.addEventListener('transitionend', handleCloseEnd);
  };

  if (details.open) {
    panel.style.maxHeight = 'none';
    panel.style.opacity = '1';
  } else {
    panel.style.maxHeight = '0px';
    panel.style.opacity = '0';
  }

  summary.addEventListener('click', (event) => {
    event.preventDefault();

    if (details.dataset.animating === 'true') return;

    if (details.open) {
      closeDetails();
    } else {
      openDetails();
    }
  });
};
  
  const initAutoplayVideos = () => {
  const videos = document.querySelectorAll(
    '.tsl-video-section .tsl-autoplay-video'
  );

  if (!videos.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(() => {
              // Autoplay may be blocked by the browser.
            });
          }
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.45
    }
  );

  videos.forEach((video) => {
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    observer.observe(video);
  });
};

  const init = () => {
    initStickyAtc(document.querySelector('.tsl-pdp'));
    initOffers();
    initAutoplayVideos();
    document.querySelectorAll('.tsl-pdp details, .tsl-faq').forEach(animateDetails);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
